<section class="intro">
    <div class="bg-image h-100" style="background-image: url('https://mdbootstrap.com/img/Photos/new-templates/glassmorphism-article/img5.jpg');">
      <div class="mask d-flex align-items-center h-100">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-7 col-xl-6">
              <div class="card mask-custom">
                <div class="card-body p-5 text-white">
  
                  <div class="my-4">
  
                    <h2 class="text-center">Registra i Dati Anagrafici</h2>
                    <p class="text-center mb-5">Registra i tuoi Dati Anagrafici per accedere alle offerte migliori!</p>
  
                    <form  [formGroup]="form" (ngSubmit)="onSubmit()">
                      <!-- 2 column grid layout with text inputs for the first and last names -->
                      <div class="row">
                        <div class="col-12 col-md-6 mb-4">
                          <div class="form-outline form-white">
                            <input type="text" id="form3Example1" class="form-control form-control-lg" />
                            <label class="form-label" for="form3Example1">Nome</label>
                          </div>
                        </div>
                        <div class="col-12 col-md-6 mb-4">
                          <div class="form-outline form-white">
                            <input type="text" id="form3Example2" class="form-control form-control-lg" />
                            <label class="form-label" for="form3Example2">Cognome</label>
                          </div>
                        </div>
                      </div>
  
                      <div class="form-outline form-white mb-4">
                        <input type="email" id="form3Example3" class="form-control form-control-lg" />
                        <label class="form-label" for="form3Example3">Codice Fiscale</label>
                      </div>
  
                      <div class="form-outline form-white mb-4">
                        <input type="password" id="form3Example4" class="form-control form-control-lg" />
                        <label class="form-label" for="form3Example4">Indirizzo</label>
                      </div>
  
                      <div class="form-check d-flex justify-content-center mb-4">
                        <input
                          class="form-check-input me-2"
                          type="checkbox"
                          value="false"
                          id="checkbox"
                          checked
                        />
                        <label class="form-check-label" for="checkbox">
                          Subscribe to our newsletter
                        </label>
                      </div>
  
                      <button type="submit" class="btn btn-light btn-block mb-4">Sign up</button>
  
                    </form>
  
                  </div>
  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
